export enum RatesheetTypes {
  BrandActivation = 'BRAND_ACTIVATION_PROJECT',
  General = 'GENERAL_PROJECT',
}

export enum RatesheetTypeNames {
  BrandActivation = 'Brand activation project',
  General = 'General project',
}
